import { Injectable, signal } from '@angular/core';

/** Presentation state only; no identity, token, or conversation is stored. */
@Injectable({ providedIn: 'root' })
export class AssistantIntroductionService {
  private readonly key = 'hub-central.assistant.login-introduction-dismissed.v1';
  readonly dismissed = signal(this.readDismissed());

  private readDismissed(): boolean {
    try {
      return sessionStorage.getItem(this.key) === 'true';
    } catch {
      return false;
    }
  }

  dismiss(): void {
    this.dismissed.set(true);
    try {
      sessionStorage.setItem(this.key, 'true');
    } catch {
      /* In-memory fallback. */
    }
  }

  endLogin(): void {
    this.dismissed.set(false);
    try {
      sessionStorage.removeItem(this.key);
    } catch {
      /* In-memory fallback. */
    }
  }
}
